import {weakMemo} from '@packages/utilities/memo';
import {Component} from '@packages/systems/wfdl';
import {getFrameIdAtPath} from '@packages/systems/component-canvas/designer';
import {UiNodeStateType} from '@packages/systems/core/records/UiNodeState';

export {getContextEnvValues} from './getContextEnvValues';
export {getRootExpression} from './getRootExpression';
export {getCurrentCanvasScrollSizes} from './getCurrentCanvasScrollSizes';
export {getClampedCanvasScrollPosition} from './getClampedCanvasScrollPosition';
export {isScrollingOverScrollableElement} from './isScrollingOverScrollableElement';
export {buildCanvasAssetMap} from './buildCanvasAssetsMap';
export {
  clampCanvasWidth,
  getActiveWorkspaceWidth,
  scrollBarWorkspaceSizeDelta,
  type ScrollBarDetails,
} from './canvasResize';

const previewModeNoFrame = {frameId: null};

const memoPreviewMode = weakMemo((focusedSymbolNativeIdPath: Array<string>) =>
  weakMemo((components: Component.ComponentMap) => {
    const frameId = getFrameIdAtPath(components, focusedSymbolNativeIdPath);
    return frameId ? {frameId} : previewModeNoFrame;
  })
);

export const buildPreviewMode = (
  uiNodeState: UiNodeStateType,
  components: Component.ComponentMap
) =>
  uiNodeState.previewModePreservedSelection
    ? memoPreviewMode(
        uiNodeState.previewModePreservedSelection.focusedSymbolNativeIdPath
      )(components)
    : previewModeNoFrame;
